/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { expVal } from '@atlassian/jira-feature-experiments';
import { defineMessage, type MessageDescriptor } from '@atlassian/jira-intl';

const titleMessage = defineMessage({
	id: 'cross-join-nudges.common.request-access-prompt-flag.title',
	defaultMessage: 'Your team is now using Confluence',
	description: 'Title of invite prompt flag to join Confluence',
});

const titleNudgeCandidate01Message = defineMessage({
	id: 'cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-01',
	defaultMessage: 'Join your teammates in Confluence',
	description: 'Title of invite prompt flag to join Confluence - Nudge Candidate 01',
});

const titleNudgeCandidate02Message = defineMessage({
	id: 'cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-02',
	defaultMessage: 'Collaborate together in Confluence',
	description: 'Title of invite prompt flag to join Confluence - Nudge Candidate 02',
});

const titleNudgeCandidate03Message = defineMessage({
	id: 'cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-03',
	defaultMessage: 'Your team is working in Confluence',
	description: 'Title of invite prompt flag to join Confluence - Nudge Candidate 03',
});

const titleNudgeCandidate04Message = defineMessage({
	id: 'cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-04',
	defaultMessage: 'Unify your projects in Confluence',
	description: 'Title of invite prompt flag to join Confluence - Nudge Candidate 04',
});

const titleNudgeCandidate05Message = defineMessage({
	id: 'cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-05',
	defaultMessage: 'Bring projects together in Confluence',
	description: 'Title of invite prompt flag to join Confluence - Nudge Candidate 05',
});

const titleNudgeCandidate06Message = defineMessage({
	id: 'cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-06',
	defaultMessage: 'Create a single source of truth',
	description: 'Title of invite prompt flag to join Confluence - Nudge Candidate 06',
});

const titleNudgeCandidate07Message = defineMessage({
	id: 'cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-07',
	defaultMessage: 'Create a single source of truth',
	description: 'Title of invite prompt flag to join Confluence - Nudge Candidate 06',
});

const descriptionMessage = defineMessage({
	id: 'cross-join-nudges.common.request-access-prompt-flag.description',
	defaultMessage:
		'Organize team knowledge, capture ideas, and share requirements for your Jira projects.',
	description: 'Description of how Confluence can be used to assist with Jira projects',
});

const descriptionNudgeCandidate01Message = defineMessage({
	id: 'cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-01',
	defaultMessage:
		'Create a single source of truth for project decisions and software documentation.',
	description:
		'Description of how Confluence can be used to assist with Jira projects - (multiple text variation exists)',
});

const descriptionNudgeCandidate02Message = defineMessage({
	id: 'cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-02',
	defaultMessage: 'Capture, consolidate, and share team knowledge, in one centralized place.',
	description:
		'Description of how Confluence can be used to assist with Jira projects - (multiple text variation exists)',
});

const descriptionNudgeCandidate03Message = defineMessage({
	id: 'cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-03',
	defaultMessage:
		'Create project pages to build a shared understanding for better decision-making.',
	description:
		'Description of how Confluence can be used to assist with Jira projects - (multiple text variation exists)',
});

const descriptionNudgeCandidate04Message = defineMessage({
	id: 'cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-04',
	defaultMessage:
		'Organize project information and sync it to Jira tasks to track and hit your goals faster.',
	description:
		'Description of how Confluence can be used to assist with Jira projects - (multiple text variation exists)',
});

const descriptionNudgeCandidate05Message = defineMessage({
	id: 'cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-05',
	defaultMessage:
		'Capture information in project pages and sync to Jira tasks to track your milestones.',
	description:
		'Description of how Confluence can be used to assist with Jira projects - (multiple text variation exists)',
});

const descriptionNudgeCandidate06Message = defineMessage({
	id: 'cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-06',
	defaultMessage:
		'Consolidate information in one place and sync to Jira tasks for automatic updates.',
	description:
		'Description of how Confluence can be used to assist with Jira projects - (multiple text variation exists)',
});

const descriptionNudgeCandidate07Message = defineMessage({
	id: 'cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-07',
	defaultMessage: 'Join your team in Confluence to consolidate project information in one place.',
	description:
		'Description of how Confluence can be used to assist with Jira projects - (multiple text variation exists)',
});

const joinButtonMessage = defineMessage({
	id: 'cross-join-nudges.common.request-access-prompt-flag.join-button',
	defaultMessage: 'Join your team',
	description: 'Action to direct access or request access to Confluence',
});

const joinButtonNudgeCandidate01Message = defineMessage({
	id: 'cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-01',
	defaultMessage: 'Join your team',
	description:
		'Action to direct access or request access to Confluence - multiple text variation exists',
});

const joinButtonNudgeCandidate02Message = defineMessage({
	id: 'cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-02',
	defaultMessage: 'Join your team',
	description:
		'Action to direct access or request access to Confluence - multiple text variation exists',
});

const joinButtonNudgeCandidate03Message = defineMessage({
	id: 'cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-03',
	defaultMessage: 'Join your team',
	description:
		'Action to direct access or request access to Confluence - multiple text variation exists',
});

const joinButtonNudgeCandidate04Message = defineMessage({
	id: 'cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-04',
	defaultMessage: 'Join Confluence',
	description:
		'Action to direct access or request access to Confluence - multiple text variation exists',
});

const joinButtonNudgeCandidate05Message = defineMessage({
	id: 'cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-05',
	defaultMessage: 'Join Confluence',
	description:
		'Action to direct access or request access to Confluence - multiple text variation exists',
});

const joinButtonNudgeCandidate06Message = defineMessage({
	id: 'cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-06',
	defaultMessage: 'Join Confluence',
	description:
		'Action to direct access or request access to Confluence - multiple text variation exists',
});

const joinButtonNudgeCandidate07Message = defineMessage({
	id: 'cross-join-nudges.common.request-access-prompt-flag.join-button-nudge-candidate-07',
	defaultMessage: 'Join Confluence',
	description:
		'Action to direct access or request access to Confluence - multiple text variation exists',
});

const titleNudgeCandidate04GalaxiaMessage = defineMessage({
	id: 'cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-04-galaxia',
	defaultMessage: 'Unify your Jira spaces in Confluence',
	description: 'Title of invite prompt flag to join Confluence - Nudge Candidate 04',
});

const titleNudgeCandidate05GalaxiaMessage = defineMessage({
	id: 'cross-join-nudges.common.request-access-prompt-flag.title-nudge-candidate-05-galaxia',
	defaultMessage: 'Bring Jira spaces together in Confluence',
	description: 'Title of invite prompt flag to join Confluence - Nudge Candidate 05',
});

const descriptionGalaxiaMessage = defineMessage({
	id: 'cross-join-nudges.common.request-access-prompt-flag.description-galaxia',
	defaultMessage:
		'Organize team knowledge, capture ideas, and share requirements for your Jira spaces.',
	description: 'Description of how Confluence can be used to assist with Jira projects',
});

const descriptionNudgeCandidate01GalaxiaMessage = defineMessage({
	id: 'cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-01-galaxia',
	defaultMessage: 'Create a single source of truth for decisions and documentation.',
	description:
		'Description of how Confluence can be used to assist with Jira projects - (multiple text variation exists)',
});

const descriptionNudgeCandidate03GalaxiaMessage = defineMessage({
	id: 'cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-03-galaxia',
	defaultMessage: 'Create pages to build a shared understanding for better decision-making.',
	description:
		'Description of how Confluence can be used to assist with Jira projects - (multiple text variation exists)',
});

const descriptionNudgeCandidate04GalaxiaMessage = defineMessage({
	id: 'cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-04-galaxia',
	defaultMessage:
		'Organize information and sync it to Jira work items to track and hit your goals faster.',
	description:
		'Description of how Confluence can be used to assist with Jira projects - (multiple text variation exists)',
});

const descriptionNudgeCandidate05GalaxiaMessage = defineMessage({
	id: 'cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-05-galaxia',
	defaultMessage:
		'Capture information in pages and sync to Jira work items to track your milestones.',
	description:
		'Description of how Confluence can be used to assist with Jira projects - (multiple text variation exists)',
});

const descriptionNudgeCandidate07GalaxiaMessage = defineMessage({
	id: 'cross-join-nudges.common.request-access-prompt-flag.description-nudge-candidate-07-galaxia',
	defaultMessage: 'Join your team in Confluence to consolidate information in one place.',
	description:
		'Description of how Confluence can be used to assist with Jira projects - (multiple text variation exists)',
});

const messages = {
	title: titleMessage,
	titleNudgeCandidate01: titleNudgeCandidate01Message,
	titleNudgeCandidate02: titleNudgeCandidate02Message,
	titleNudgeCandidate03: titleNudgeCandidate03Message,
	titleNudgeCandidate04: titleNudgeCandidate04Message,
	titleNudgeCandidate05: titleNudgeCandidate05Message,
	titleNudgeCandidate06: titleNudgeCandidate06Message,
	titleNudgeCandidate07: titleNudgeCandidate07Message,
	description: descriptionMessage,
	descriptionNudgeCandidate01: descriptionNudgeCandidate01Message,
	descriptionNudgeCandidate02: descriptionNudgeCandidate02Message,
	descriptionNudgeCandidate03: descriptionNudgeCandidate03Message,
	descriptionNudgeCandidate04: descriptionNudgeCandidate04Message,
	descriptionNudgeCandidate05: descriptionNudgeCandidate05Message,
	descriptionNudgeCandidate06: descriptionNudgeCandidate06Message,
	descriptionNudgeCandidate07: descriptionNudgeCandidate07Message,
	joinButton: joinButtonMessage,
	joinButtonNudgeCandidate01: joinButtonNudgeCandidate01Message,
	joinButtonNudgeCandidate02: joinButtonNudgeCandidate02Message,
	joinButtonNudgeCandidate03: joinButtonNudgeCandidate03Message,
	joinButtonNudgeCandidate04: joinButtonNudgeCandidate04Message,
	joinButtonNudgeCandidate05: joinButtonNudgeCandidate05Message,
	joinButtonNudgeCandidate06: joinButtonNudgeCandidate06Message,
	joinButtonNudgeCandidate07: joinButtonNudgeCandidate07Message,
	titleNudgeCandidate04Galaxia: titleNudgeCandidate04GalaxiaMessage,
	titleNudgeCandidate05Galaxia: titleNudgeCandidate05GalaxiaMessage,
	descriptionGalaxia: descriptionGalaxiaMessage,
	descriptionNudgeCandidate01Galaxia: descriptionNudgeCandidate01GalaxiaMessage,
	descriptionNudgeCandidate03Galaxia: descriptionNudgeCandidate03GalaxiaMessage,
	descriptionNudgeCandidate04Galaxia: descriptionNudgeCandidate04GalaxiaMessage,
	descriptionNudgeCandidate05Galaxia: descriptionNudgeCandidate05GalaxiaMessage,
	descriptionNudgeCandidate07Galaxia: descriptionNudgeCandidate07GalaxiaMessage,
};

interface VariableMessagingKey {
	title: keyof typeof messages;
	description: keyof typeof messages;
	joinButton: keyof typeof messages;
}

export const EntityList = [
	'nudgeCandidate01',
	'nudgeCandidate02',
	'nudgeCandidate03',
	'nudgeCandidate04',
	'nudgeCandidate05',
	'nudgeCandidate06',
	'nudgeCandidate07',
] as const;

export type EntityId = (typeof EntityList)[number] | 'default';

type EntityIdGalaxia =
	| EntityId
	| 'defaultGalaxia'
	| 'nudgeCandidate01Galaxia'
	| 'nudgeCandidate02Galaxia'
	| 'nudgeCandidate03Galaxia'
	| 'nudgeCandidate04Galaxia'
	| 'nudgeCandidate05Galaxia'
	| 'nudgeCandidate06Galaxia'
	| 'nudgeCandidate07Galaxia';

const messageVariantsKeyMap: Record<EntityIdGalaxia, VariableMessagingKey> = {
	default: {
		title: 'title',
		description: 'description',
		joinButton: 'joinButton',
	},
	nudgeCandidate01: {
		title: 'titleNudgeCandidate01',
		description: 'descriptionNudgeCandidate01',
		joinButton: 'joinButtonNudgeCandidate01',
	},
	nudgeCandidate02: {
		title: 'titleNudgeCandidate02',
		description: 'descriptionNudgeCandidate02',
		joinButton: 'joinButtonNudgeCandidate02',
	},
	nudgeCandidate03: {
		title: 'titleNudgeCandidate03',
		description: 'descriptionNudgeCandidate03',
		joinButton: 'joinButtonNudgeCandidate03',
	},
	nudgeCandidate04: {
		title: 'titleNudgeCandidate04',
		description: 'descriptionNudgeCandidate04',
		joinButton: 'joinButtonNudgeCandidate04',
	},
	nudgeCandidate05: {
		title: 'titleNudgeCandidate05',
		description: 'descriptionNudgeCandidate05',
		joinButton: 'joinButtonNudgeCandidate05',
	},
	nudgeCandidate06: {
		title: 'titleNudgeCandidate06',
		description: 'descriptionNudgeCandidate06',
		joinButton: 'joinButtonNudgeCandidate06',
	},
	nudgeCandidate07: {
		title: 'titleNudgeCandidate07',
		description: 'descriptionNudgeCandidate07',
		joinButton: 'joinButtonNudgeCandidate07',
	},
	defaultGalaxia: {
		title: 'title',
		description: 'descriptionGalaxia',
		joinButton: 'joinButton',
	},
	nudgeCandidate01Galaxia: {
		title: 'titleNudgeCandidate01',
		description: 'descriptionNudgeCandidate01Galaxia',
		joinButton: 'joinButtonNudgeCandidate01',
	},
	nudgeCandidate02Galaxia: {
		title: 'titleNudgeCandidate02',
		description: 'descriptionNudgeCandidate02',
		joinButton: 'joinButtonNudgeCandidate02',
	},
	nudgeCandidate03Galaxia: {
		title: 'titleNudgeCandidate03',
		description: 'descriptionNudgeCandidate03Galaxia',
		joinButton: 'joinButtonNudgeCandidate03',
	},
	nudgeCandidate04Galaxia: {
		title: 'titleNudgeCandidate04Galaxia',
		description: 'descriptionNudgeCandidate04Galaxia',
		joinButton: 'joinButtonNudgeCandidate04',
	},
	nudgeCandidate05Galaxia: {
		title: 'titleNudgeCandidate05Galaxia',
		description: 'descriptionNudgeCandidate05Galaxia',
		joinButton: 'joinButtonNudgeCandidate05',
	},
	nudgeCandidate06Galaxia: {
		title: 'titleNudgeCandidate06',
		description: 'descriptionNudgeCandidate06',
		joinButton: 'joinButtonNudgeCandidate06',
	},
	nudgeCandidate07Galaxia: {
		title: 'titleNudgeCandidate07',
		description: 'descriptionNudgeCandidate07Galaxia',
		joinButton: 'joinButtonNudgeCandidate07',
	},
};

export const getDynamicMessages = (
	isContextualBandit: boolean,
	entityId: EntityId,
):
	| {
			title: MessageDescriptor;
			description: MessageDescriptor;
			joinButton: MessageDescriptor;
	  }
	| undefined => {
	// Handle case when entityId is unexpected
	if (!(entityId in messageVariantsKeyMap)) {
		return undefined;
	}
	// If v2B is not enabled we just passthrough default message keys
	const usedEntityId: EntityId = isContextualBandit ? entityId : 'default';

	// if experiment is enabled and usedEntityIdGalaxia exists then use it
	// else use the usedEntityId
	const entityIdToUse: EntityIdGalaxia = expVal('project-terminology-refresh', 'isEnabled', false)
		? `${usedEntityId}Galaxia`
		: usedEntityId;

	const titleKey = messageVariantsKeyMap[entityIdToUse].title;
	const descriptionKey = messageVariantsKeyMap[entityIdToUse].description;
	const joinButtonKey = messageVariantsKeyMap[entityIdToUse].joinButton;

	return {
		title: messages[titleKey],
		description: messages[descriptionKey],
		joinButton: messages[joinButtonKey],
	};
};
